import { useState } from "react";
import { Container, Card, CardContent, Typography, Box, Button, CardActions } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
/**
 * 【TKG_RESERVE_0110】
 * @returns 新規ユーザー承認待ち画面
 */
export const AwaitingApprovalScreen = () => {
  const [showNotice, setShowNotice] = useState(false);

  return (
    <>
    <Container 
      maxWidth="sm" 
      sx={{
        minHeight: '90vh',
        textAlign: 'center',
        paddingTop: '20vh'
      }}
    >
      <Card sx={{ width: '100%', borderRadius: 2, boxShadow: 3 }}>
        <CardContent sx={{ textAlign: 'center', padding: 3 }}>
          <Typography variant="h6" sx={{ color: '#616161', fontWeight: 'bold', marginBottom: 2 }}>
            ユーザー登録が完了しました
          </Typography>          
          <Typography variant="body1" sx={{ color: '#616161', marginBottom: 3 }}>
            あなたのLINEアカウントで予約システムに登録を行いました。<br />管理者があなたの登録を承認した後、利用できるようになります。
          </Typography>
          <Box sx={{ marginTop: 3 }}>
            <CheckCircle sx={{ fontSize: 60, color: '#66b9d9', marginBottom: 2 }} />
            <Typography variant="body2" sx={{ color: '#FB8C00' }}>
              <strong>ご登録ありがとうございます！</strong>
            </Typography>
          </Box>
        </CardContent>
      </Card>

      {/* 注釈メッセージ */}
      <Box sx={{ paddingTop: 4, paddingBottom: 2 }}>
        {!showNotice ? (
            <Button
              variant="outlined"
              startIcon={<HelpOutlineIcon />}
              onClick={() => setShowNotice(true)}
            >
              ずっと承認されずこの画面から変わりません
            </Button>
        ) : (
          <Card elevation={3} sx={{ borderRadius: 3 }}>
            <CardActions>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => setShowNotice(false)}
                sx={{ margin: '0 auto', marginBottom: 2 }}
              >
                閉じる
              </Button>
            </CardActions>
            <CardContent sx={{ p: 4 }}>
              <Box sx={{ mt: 2 }}>
                <Typography variant="body1" paragraph>
                  承認は公式LINEにご登録いただいている方に限らせていただきます。未登録の方は、公式Instagramよりお問い合わせください。
                </Typography>
                <Typography variant="body1" paragraph>
                  また、公式LINEにご登録頂いていても、管理者側で認識できない場合がございます。特に、ご登録直後でまだメッセージの送信がない場合は承認ができません。そのため、ご登録いただいた際にはスタンプや簡単なメッセージを1通お送りいただけますと幸いです。通常、予約システムへの登録から2日以内を目安に承認しております。
                </Typography>
              </Box>
            </CardContent>
          </Card>
        )}
      </Box>
    </Container>
    </>
  );
};
